var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E48686"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 6.03333C8.8 5.76667 9.2 5.76667 9.4 6.03333L12.4 10.0333C12.6472 10.363 12.412 10.8333 12 10.8333H6C5.58798 10.8333 5.35279 10.363 5.6 10.0333L8.6 6.03333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIncrease);
export default __webpack_public_path__ + "static/media/arrow-increase.2b9686764b01f0b1082c3259f6280cf6.svg";
export { ForwardRef as ReactComponent };